import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import type { DynamicAction } from '@shared/registry';

import type { DisclaimerConfig } from './disclaimer.types';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Disclaimer {
  readonly config = input.required<DisclaimerConfig>();
  readonly action = output<DynamicAction>();

  protected onLinkClick(event: Event): void {
    const action = this.config().action;
    if (action) {
      event.preventDefault();
      this.action.emit(action);
    }
  }
}
